"use strict";

const URL = require("whatwg-url-compat");

module.exports = function (core) {
  core.URL = URL.createURLConstructor();
};



//////////////////
// WEBPACK FOOTER
// ./~/jsdom/lib/jsdom/living/url.js
// module id = 3180
// module chunks = 0